/**
 * assets/cart-drawer.js — cart drawer runtime. 242 lines.
 * Expects window.Clyro from layout/theme.liquid.
 *
 * ZONE MAP (grep "ZONE:" to jump):
 *   ZONE: helpers      ~line 8   — safeCheckout, setDrawerOpen, setAllDrawersOpen
 *   ZONE: cartUi       ~line 50  — bindCartUiOnce — quantity/remove actions
 *   ZONE: initDrawer   ~line 88  — fetch + render cart HTML into [data-cart-items]
 *   ZONE: renderCart   ~line 110 — builds line items + totals from cart JSON
 *   ZONE: boot         ~line 228 — boot on DOMContentLoaded + editor reload guard
 *
 * DATA HOOKS (read from snippets/cart-drawer-panel.liquid — never rename):
 *   .clyro-cart-drawer            — root container
 *   .is-open                      — open state class (toggled here)
 *   .clyro-cart-drawer__overlay   — backdrop click closes drawer
 *   .clyro-cart-drawer__close     — close button
 *   [data-cart-items-wrap]        — shown when cart has items
 *   [data-cart-items]             — line items injected as HTML
 *   [data-cart-empty]             — shown when cart is empty
 *   [data-cart-footer]            — subtotal + checkout shown when has items
 *   [data-cart-subtotal]          — subtotal text node
 *   [data-cart-discount]          — discount amount
 *   [data-cart-discount-row]      — discount row wrapper
 *   [data-cart-line]              — template node cloned per line item
 *   [data-line-image/link/title/variant/price/original/qty] — per-line nodes
 *   [data-clyro-action]           — +/- /remove buttons
 *   [data-clyro="close"]          — any element that closes the drawer on click
 *
 * EVENTS listened:
 *   clyro:cart:open               — fired by header.js / any trigger
 *   clyro:cart:close
 *   clyro:cart:refresh            — re-fetches cart JSON
 *   clyro:cart:updated            — emitted after successful line update
 */
(function () {
  var drawerRenderers = [];
  var cartUiBound = false;

  function safeCheckout(event, link) {
    try {
      if (event) event.preventDefault();
      if (!link) return false;
      var href = link.getAttribute('href');
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var checkoutUrl = href || root + 'cart/checkout';
      var inIframe = false;
      try { inIframe = window.top !== window.self; } catch (_) { inIframe = true; }
      if (inIframe || (window.Shopify && Shopify.designMode)) {
        var popup = window.open(checkoutUrl, '_blank', 'noopener');
        if (!popup) window.location.href = checkoutUrl;
        return false;
      }
      window.location.href = checkoutUrl;
    } catch (_) {
      window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/checkout';
    }
    return false;
  }
  window.ClyroSafeCheckout = safeCheckout;

  function setDrawerOpen(root, open) {
    root.classList.toggle('is-open', open);
    var aside = root.querySelector('.clyro-cart-drawer__aside');
    var overlay = root.querySelector('.clyro-cart-drawer__overlay');
    if (aside) aside.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (overlay) overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function setAllDrawersOpen(open) {
    document.querySelectorAll('[data-section-type="cart-drawer"]').forEach(function (root) {
      setDrawerOpen(root, open);
    });
  }

  function pruneRenderers() {
    drawerRenderers = drawerRenderers.filter(function (entry) {
      return entry.root && document.contains(entry.root);
    });
  }

  function bindCartUiOnce() {
    if (cartUiBound || !window.Clyro) return;
    cartUiBound = true;

    Clyro.on('cart:open', function () { setAllDrawersOpen(true); });
    Clyro.on('cart:close', function () { setAllDrawersOpen(false); });

    Clyro.on('cart:updated', function (e) {
      pruneRenderers();
      drawerRenderers.forEach(function (entry) { entry.render(e.detail); });
    });

    document.addEventListener('click', function (e) {
      var closeEl = e.target.closest('[data-clyro="close"]');
      if (!closeEl || !closeEl.closest('[data-section-type="cart-drawer"]')) return;
      var href = closeEl.getAttribute && closeEl.getAttribute('href');
      if (href && href !== '#') {
        Clyro.cart.close();
        return;
      }
      e.preventDefault();
      Clyro.cart.close();
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-line-link]');
      if (!link || !link.closest('[data-section-type="cart-drawer"]')) return;
      var href = link.getAttribute('href');
      if (href && href !== '#') Clyro.cart.close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!Clyro.cart || !Clyro.cart.isOpen()) return;
      Clyro.cart.close();
    });
  }

  function initDrawer(root) {
    if (!root || root.dataset.clyroBound === '1' || !window.Clyro) return;
    root.dataset.clyroBound = '1';
    bindCartUiOnce();

    var tpl = document.getElementById('cart-line-template-' + root.dataset.sectionId);
    if (!tpl) return;

    var previewAlwaysOpen = root.getAttribute('data-preview-always-open') === 'true';
    if (previewAlwaysOpen) {
      Clyro.cart._open = true;
      setDrawerOpen(root, true);
      if (Clyro.scrollLock) Clyro.scrollLock.reset();
    }

    var itemsWrap = root.querySelector('[data-cart-items-wrap]');
    var itemsList = root.querySelector('[data-cart-items]');
    var footer = root.querySelector('[data-cart-footer]');
    var emptyState = root.querySelector('[data-cart-empty]');
    var countBadge = root.querySelector('[data-cart-count-badge]');
    var subtotalEls = Clyro.qsa(root, '[data-cart-subtotal]');
    var discountRow = root.querySelector('[data-cart-discount-row]');
    var discountEl = root.querySelector('[data-cart-discount]');
    var updating = false;

    function setUpdating(on) {
      updating = !!on;
      root.classList.toggle('is-updating', updating);
    }

    function runCartChange(line, qty) {
      setUpdating(true);
      var done = function () { setUpdating(false); };
      Clyro.cart.change(line, qty).then(done).catch(done);
      setTimeout(done, 4000);
    }

    function bindLineActions(node, line) {
      Clyro.qsa(node, '[data-clyro-action]').forEach(function (btn) {
        var action = btn.getAttribute('data-clyro-action');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (updating) return;
          var items = (Clyro.cart.state && Clyro.cart.state.items) || [];
          var item = items[line - 1];
          var qty = item ? Number(item.quantity) || 0 : 0;
          if (action === 'remove' || (action === 'dec' && qty <= 1)) runCartChange(line, 0);
          else if (action === 'dec') runCartChange(line, qty - 1);
          else if (action === 'inc') runCartChange(line, qty + 1);
        });
      });
    }

    function buildLine(item, index) {
      var line = index + 1;
      var node = tpl.content.firstElementChild.cloneNode(true);
      node.setAttribute('data-line', String(line));
      bindLineActions(node, line);

      var img = node.querySelector('[data-line-image]');
      if (item.image) {
        img.src = item.image;
        img.alt = item.product_title || item.title || '';
        Clyro.show(img);
      }

      var url = item.url || '#';
      Clyro.qsa(node, '[data-line-link]').forEach(function (a) { a.href = url; });
      node.querySelector('[data-line-title]').textContent = item.product_title || item.title || '';

      var variantEl = node.querySelector('[data-line-variant]');
      if (item.variant_title && item.variant_title !== 'Default Title') {
        variantEl.textContent = item.variant_title;
        Clyro.show(variantEl);
      }

      node.querySelector('[data-line-qty]').textContent = String(item.quantity);

      var finalPrice = item.final_line_price != null ? item.final_line_price : item.line_price;
      var originalPrice = item.original_line_price != null ? item.original_line_price : item.line_price;
      node.querySelector('[data-line-price]').textContent = Clyro.money(finalPrice);

      var originalEl = node.querySelector('[data-line-original]');
      if (originalEl && originalPrice > finalPrice) {
        originalEl.textContent = Clyro.money(originalPrice);
        Clyro.show(originalEl);
      }

      return node;
    }

    function render(state) {
      setUpdating(false);
      var hasItems = state && state.item_count > 0;

      if (countBadge) {
        if (hasItems) {
          countBadge.textContent = String(state.item_count);
          Clyro.show(countBadge);
        } else {
          Clyro.hide(countBadge);
        }
      }

      subtotalEls.forEach(function (el) {
        el.textContent = Clyro.money(state ? state.total_price : 0);
      });

      var discount = state && state.total_discount ? Number(state.total_discount) : 0;
      if (discountRow && discountEl) {
        if (discount > 0) {
          discountEl.textContent = '−' + Clyro.money(discount);
          Clyro.show(discountRow);
        } else {
          Clyro.hide(discountRow);
        }
      }

      itemsList.replaceChildren();
      if (hasItems) {
        var frag = document.createDocumentFragment();
        state.items.forEach(function (item, i) { frag.appendChild(buildLine(item, i)); });
        itemsList.appendChild(frag);
        Clyro.show(itemsWrap);
        Clyro.show(footer);
        Clyro.hide(emptyState);
      } else {
        Clyro.hide(itemsWrap);
        Clyro.hide(footer);
        Clyro.show(emptyState);
      }
    }

    pruneRenderers();
    drawerRenderers.push({ root: root, render: render });
    render(Clyro.cart.state);
    setDrawerOpen(root, previewAlwaysOpen || Clyro.cart.isOpen() || root.classList.contains('is-open'));
  }

  function boot() {
    document.querySelectorAll('[data-section-type="cart-drawer"]').forEach(initDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('[data-section-type="cart-drawer"]');
    if (root) initDrawer(root);
  });
})();
